@if (!hideLauncher() || isOpen()) {
<button class="ia-launcher" type="button" (click)="open()">
    <span class="ia-launcher__icon" aria-hidden="true">
        <img
            src="https://fover-docs-cdn-front.nyc3.cdn.digitaloceanspaces.com/rapidocs-images/logo.png"
        />
    </span>
    <span class="ia-launcher__label">{{ 'iaChat.launcherLabel' | translate }}</span>
</button>
}

@if (isOpen()) {
    <ia-chat
        [orderId]="orderId()"
        [standalone]="standalone()"
        [initialDraft]="initialDraft()"
        (close)="close()"
        (concluded)="concluded.emit($event)"
    />
}
